import clsx from 'clsx'

import { Card } from '@/shared/ui/Card'

import { Skeleton } from './Skeleton'

export type PageDetailCardSkeletonProps = {
  className?: string
  lines?: number
  withIconTitle?: boolean
}

/**
 * Card genérico de detalhe (sobre, formulário, seção de conteúdo).
 */
export const PageDetailCardSkeleton = ({
  className,
  lines = 3,
  withIconTitle = true
}: PageDetailCardSkeletonProps) => (
  <Card className={clsx('card-gamification mb-4 rounded-3xl border border-contour shadow-sm', className)}>
    <Card.Body className="flex flex-col gap-4 p-5">
      {withIconTitle && (
        <div className="flex items-center gap-2">
          <Skeleton variant="thumb" className="size-8" />
          <Skeleton className="h-4 w-36" />
        </div>
      )}
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton
          key={index}
          className={clsx('h-3', index === lines - 1 ? 'w-[78%]' : 'w-full')}
        />
      ))}
    </Card.Body>
  </Card>
)
